// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2hh6C","error":"Textarea_error__Z2Fkn","readonly":"Textarea_readonly__2PZKA","disabled":"Textarea_disabled__29c7l"};